import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import type React from "react";

function Loader({
	position = undefined,
	style = {},
	loaderColor = undefined,
	fullscreen = false,
	size,
}: {
	position?: string;
	style?: React.CSSProperties;
	loaderColor?: string;
	fullscreen?: boolean;
	size?: number;
}) {
	const fullscreenStyles = fullscreen
		? {
				position: "fixed" as const,
				inset: 0,
				width: "100dvw",
				height: "100dvh",
				zIndex: 1300,
			}
		: {
				position: position ? ("relative" as const) : ("static" as const),
				top: position,
			};

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				...fullscreenStyles,
			}}
			style={style}
		>
			<CircularProgress
				color={loaderColor ? undefined : "primary"}
				sx={loaderColor ? { color: loaderColor } : {}}
				size={size ?? (fullscreen ? 56 : undefined)}
			/>
		</Box>
	);
}

export default Loader;
